module.exports = __webpack_public_path__ + "static/img/Jellorio.11fc6bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Jellorio.jpg
// module id = +F8z
// module chunks = 1